import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import store from '@redux/store';
import reportWebVitals from './reportWebVitals';
import '@utils/lang/i18next';
import 'bootstrap/dist/css/bootstrap.min.css';
import GlobalStyles from '@components/global';
import { ProvideAuth } from '@utils/hook/useAuth';
import { pdfjs } from 'react-pdf';
import { loadZeusPayment } from '@utils/helpers/loadZeus';

// pdfjs.GlobalWorkerOptions.workerSrc = new URL('pdfjs-dist/build/pdf.worker.min.js', import.meta.url).toString();
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const renderApp = () => {
    const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
    root.render(
        <React.StrictMode>
            <ProvideAuth>
                <Provider store={store}>
                    <GlobalStyles>
                        <App />
                    </GlobalStyles>
                </Provider>
            </ProvideAuth>
        </React.StrictMode>,
    );
};

loadZeusPayment()
    .catch((err) => console.error('[Payment] Failed to load ZEUS config:', err))
    .finally(renderApp);

const appVersion = '6.0.3';

localStorage.setItem('applicationVersion', appVersion);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
